import { createAction, props } from '@ngrx/store';
import { MemberAttachment } from './member-attachment.model';

// fetch 
export const fetchMemberAttachmentListData = createAction('[Data] fetch club user list');
export const fetchMemberAttachmentListSuccess = createAction('[Data] fetch club user list success', props<{ MemberAttachmentListdata: MemberAttachment[] }>())
export const fetchMemberAttachmentListFail = createAction('[Data fetch club user list failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records member attachment',
    props<{ memberId: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records member attachment success', 
    props<{ listData: MemberAttachment[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records member attachment failure', 
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state member attachment',
);